import { render } from "./ProductReassign.vue?vue&type=template&id=3072837a&ts=true"
import script from "./ProductReassign.ts?vue&type=script&lang=ts&external"
export * from "./ProductReassign.ts?vue&type=script&lang=ts&external"

import "./ProductReassign.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__